export default __webpack_public_path__ + "static/media/BC_246_BC_R9326.21854f29.jpg";